import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { OappService } from '../oapp.service';
import { map, take, debounceTime, first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {
  constructor(public db: AngularFirestore,
    public oapp: OappService) { }

  // createUser(value, avatar) {
  //   console.log('createuser',value,avatar);
  //   return this.db.collection('users').add({
  //     empresa: value.empresa,
  //     name: value.name,
  //     surname: value.surname,
  //     email: value.email,
  //     avatar: avatar ? avatar : 'assets/images/user/user.png',
  //     nameToSearch: value.name.toLowerCase()
  //   });
  // }

  createUser(value, avatar, empresa) {
    var personas = {
      email: value.email,
      emailSecundario: value.email,
      eps: "No registrado",
      fechaNacimiento:"No registrado",
      id: value.id,
      nacionalidad:"Colombia",
      primerApellido:value.surname.toLowerCase(),
      primerNombre: value.name.toLowerCase(),
      segundoApellido:"",
      segundoNombre:"",
      telefono:"",
      tipoID:"CC",
      tipoSangre:"No registrado",
      propiedades:{[empresa.id_reg]:{}},
      ultimaPropiedad: empresa.id_reg,
    }
      this.db.collection(`personas`).doc(personas.tipoID+personas.id).set(personas).then(res=>{
        console.log('persona creada',res);
      })
      this.db.collection(`empresas/${empresa.id_reg}/personas`).doc(personas.tipoID+personas.id).set(personas).then(res=>{
        console.log('persona creada',res);
      })
      return this.db.collection(`empresas/${empresa.id_reg}/userProfile`).doc(value.email).set({
        admin: false,
        // cliente: value.empresa === this.oapp.datosapp.id_empresa ? false : true,
        empresa: empresa,
        id: value.id,
        firstname: value.name.toLowerCase(),
        lastname: value.surname.toLowerCase(),
        email: value.email,
        image: avatar ? avatar : 'assets/images/user/user.png',
        nameToSearch: `${value.name.toLowerCase()} ${value.surname.toLowerCase()}`,
        phone: ''
      });
  }


  createUserExiste(personas, userprofile, empresa) { //Si ya existe un user profile principal lo crea en otras empresas
      this.db.collection(`empresas/${empresa.id_reg}/personas`).doc(personas.tipoID+personas.id).set(personas).then(res=>{
        console.log('persona creada en empresa',res);
      })
      return this.db.collection(`empresas/${empresa.id_reg}/userProfile`).doc(userprofile.email).set(userprofile);
  }




  updateUser(userKey, value) {
    value.nameToSearch = value.name.toLowerCase();
    return this.db.collection('usersContact').doc(userKey).set(value);
  }
  public genRef(plink, id) {
    console.log(plink, id)
    let ref = this.db.collection(plink).doc(id);
    return ref.ref;
  }

  searchUsers(searchValue) {
    return this.db.collection('usersContact', ref => ref.where('nameToSearch', '>=', searchValue)
      .where('nameToSearch', '<=', searchValue + '\uf8ff'))
      .snapshotChanges()
  }

  searchUsersByCodigo(value) {
    return this.db.collection('usersContact', ref => ref.orderBy('age').startAt(value)).snapshotChanges();
  }

  getUser(userKey) {
    return this.db.collection('usersContact').doc(userKey).snapshotChanges();
  }
  getUsers() {
    return this.db.collection('usersContact').snapshotChanges();
  }

  deleteUser(contactKey) {
    return this.db.collection('usersContact').doc(contactKey).delete();
  }
  getempresa(empresa) {
    return new Promise((resolve, reject) => {
    this.db.collection(`empresas/`+this.oapp.datosapp.id_empresa+`/clientes`).doc(empresa).snapshotChanges().
    pipe(first()).toPromise().then((empresa)=>{    
      const devuelve =empresa.payload.data();
      console.log('get empresa',empresa, empresa.payload.ref,devuelve)
      const empresaInfo ={ 
        refefencia: empresa.payload.ref,
        data: empresa.payload.data()

      }
      resolve(empresaInfo);
    });
  })
  }
}
